var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Children } from 'react';
import propTypes from 'prop-types';
import Text from './text.js';
import styled from 'styled-components';
export const TabGroup = styled.nav.withConfig({ displayName: "brc-TabGroup", componentId: "brc-busv53" }) `
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
  border-bottom: 1px solid ${({ theme }) => theme.neutral300};
  padding-top: 16px;

  & > * {
    padding: 8px 0 16px;
    margin-right: 48px;
  }

  & > *:last-child {
    margin-right: 0;
  }
`;
export const Tab = styled(Text).withConfig({
    shouldForwardProp: (prop) => !['isActive'].includes(prop),
}) `
  position: relative;
  color: ${({ theme }) => theme.neutral500};

  &:hover {
    color: ${({ theme }) => theme.neutral500};
  }

  &::after {
    content: '';
    width: 100%;
    height: 4px;
    background-color: ${({ isActive, theme }) => (isActive ? theme.azure : 'transparent')};
    border-radius: 2px;
    position: absolute;
    bottom: 0;
    left: 0;
  }
`;
Tab.propTypes = {
    isActive: propTypes.bool,
};
export default (_a) => {
    var { children } = _a, props = __rest(_a, ["children"]);
    return (_jsx(TabGroup, Object.assign({ "data-testid": "tab-group" }, props, { children: Children.toArray(children).map(({ type, key, props }) => (_jsx(Tab, Object.assign({ as: type }, props), key))) })));
};
//# sourceMappingURL=tab-group.js.map